if (!customElements.get('mo-cart-add')) {
  customElements.define('mo-cart-add', class extends HTMLElement {
    static pending = false;
    connectedCallback() {
      if (this.ready) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.ready = true;
      form.addEventListener('submit', async event => {
        if (event.defaultPrevented) return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        event.preventDefault();
        const button = event.submitter || form.querySelector('button[type="submit"]');
        if (this.constructor.pending || !form.reportValidity() || button.disabled) return;
        this.constructor.pending = true;
        const status = this.querySelector('[role="alert"]');
        const label = button.querySelector('[data-cart-add-label]') || button.querySelector('span');
        const originalLabel = label.textContent;
        const controls = [...form.querySelectorAll('button[type="submit"]')].map(control => [control, control.disabled]);
        status.hidden = true;
        controls.forEach(([control]) => { control.disabled = true; });
        form.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.loading;
        try {
          const body = new FormData(form);
          if (button.name) body.set(button.name, button.value);
          body.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
          body.append('sections_url', window.location.pathname);
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || this.dataset.error);
          this.dispatchEvent(new CustomEvent('mo:cart-added', { bubbles: true, detail: { variantId: body.get('id') } }));
          drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          if (!state.sections?.['cart-drawer']) {
            window.location.assign(window.Shopify.routes.root + 'cart');
            return;
          }
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
          drawer.querySelector('.drawer__close')?.focus({ preventScroll: true });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mo-cart-add', productVariantId: body.get('id'), cartData: state });
          }
        } catch (error) {
          status.textContent = error.message === 'Failed to fetch' ? this.dataset.error : (error.message || this.dataset.error);
          status.hidden = false;
          status.focus();
        } finally {
          this.constructor.pending = false;
          if (this.isConnected) {
            controls.forEach(([control, disabled]) => { control.disabled = disabled; });
            form.removeAttribute('aria-busy');
            button.removeAttribute('aria-busy');
            label.textContent = originalLabel;
          }
        }
      });
    }
  });
}

